import {
  RETRIEVE_EMAIL,
  UPDATE_EMAIL,
} from 'containers/AwarenessCenter/WizardCampaign/steps/GenerateEmailsStep/constants'
import { GET_EMAIL_PREVIEW_ASYNC } from 'containers/AwarenessCenter/WizardCampaign/steps/MessageStep/constants'
import {
  AUTOMATED_LEVEL_BASED_TRAINING,
  CUSTOM_MODULE_IMAGE_PREVIEW,
  CUSTOM_MODULE_NAME_FILE,
  CUSTOM_MODULE_NAME_URL,
  CUSTOM_MODULE_TYPES,
  SOURCE_VALUES,
  TRAINING_VIDEO_TYPES,
} from 'containers/AwarenessCenter/WizardCampaign/steps/TrainingModuleStep/constants'
import { mapCompletionNotificationSettingsFromApi } from 'containers/AwarenessCenter/WizardCampaign/steps/utils'

import {
  CHANGE_SELECTION_DATA,
  CHANGE_TABLE_FILTERS,
  CHANGE_TRAINING_RESULTS_MODAL_POSTPONED_DATE,
  CHANGE_TRAINING_RESULTS_MODAL_STATUS,
  CLEAR_TABLE_FILTERS,
  CREATE_ASSIGNMENT_RESENDS_ASYNC,
  CREATE_MANUAL_COMPLETIONS_ASYNC,
  CREATE_PARTICIPANT_EXCLUSIONS_ASYNC,
  DOWNLOAD_PARTICIPANTS_CSV_ASYNC,
  DUPLICATE_CAMPAIGN_ASYNC,
  EMERGENCY_STOP_REQUEST_ASYNC,
  EXTEND_COLLECTION_PERIOD_ASYNC,
  EXTEND_PARTICIPANT_DEADLINES_ASYNC,
  GET_CAMPAIGN_COMPLETION_PROGRESS_ASYNC,
  GET_CAMPAIGN_DATA_ASYNC,
  GET_CAMPAIGN_DEPARTMENT_OUTCOMES_ASYNC,
  GET_CAMPAIGN_FINAL_RESULTS_ASYNC,
  GET_CAMPAIGN_HEALTH_ASYNC,
  GET_CAMPAIGN_INFO_ASYNC,
  GET_CAMPAIGN_PARTICIPANTS_ASYNC,
  GET_CAMPAIGN_SIMULATION_FUNNEL_ASYNC,
  GET_CAMPAIGN_SIMULATION_OVERVIEW_ASYNC,
  GET_CAMPAIGN_STATUS_COUNTS_ASYNC,
  GET_CAMPAIGN_STATUS_OVER_TIME_ASYNC,
  GET_REPORT_PARTICIPANTS_LIST_ASYNC,
  GET_REPORT_SUMMARY_ASYNC,
  NOTIFY_MANAGERS_ASYNC,
  PAUSE_PARTICIPANT_REMINDERS_ASYNC,
  RESET_PARTICIPANT_DEADLINES_ASYNC,
  RESET_REPORT,
  RESET_SELECTION_DATA,
  RESET_TRAINING_PROGRESS_ASYNC,
  RESUME_PARTICIPANT_REMINDERS_ASYNC,
  REVERT_MANUAL_COMPLETIONS_ASYNC,
  SAVE_DRAFT_ASYNC,
  SAVE_MANUAL_TRAINING_RESULTS_ASYNC,
  SEGMENT_FILTER_CHANGE,
  SEND_REMINDERS_ASYNC,
  SEND_STATUS_REMINDERS_ASYNC,
  SET_TABLE_FILTERS,
} from './constants'

const DEFAULT_FILTER = {
  search: '',
  simulationResultTypes: [],
  trainingResultTypes: [],
  departments: [],
  trainingResults: [],
  levels: [],
  scenarios: [],
  trainingIds: [],
}

const DEFAULT_SELECTION_DATA = {
  selectionIds: [],
  allItems: false,
}

const getVideoVendor = (video) => {
  if (video.vendor) {
    return video.vendor
  }

  if (video.is_deleted) {
    return null
  }

  return SOURCE_VALUES.CUSTOM_MODULE
}

export default function () {
  const initialState = {
    data: {},
    loader: false,
    tableLoader: false,
    summaryLoader: false,
    duplicateCampaignLoader: false,
    stopCampaignLoader: false,
    campaignStopped: false,
    trainingResultsModalLoader: false,
    error: null,
    segment: null,
    emailPreviewLoader: false,
    emailPreviewError: null,
    emailPreview: null,
    reportParticipantsData: {
      meta: {
        scenarios: [],
        departments: [],
      },
      results: [],
    },
    filters: DEFAULT_FILTER,
    emailDetails: {
      data: null,
      loader: false,
      error: null,
    },
    summaryData: {
      campaignParticipantGroups: [],
      assessments: {},
      statistic: {
        departments: [],
        scenarios: [],
        campaigns: {
          items: [],
        },
      },
    },
    trainingResultsModalStatus: '',
    trainingResultsPostponedDate: null,
    createdCampaignId: null,
    selectionData: DEFAULT_SELECTION_DATA,
    health: {
      data: null,
      loader: false,
      error: null,
    },
    statusCounts: {
      data: null,
      loader: false,
      error: null,
    },
    statusOverTime: {
      data: null,
      loader: false,
      error: null,
    },
    completionProgress: {
      data: null,
      loader: false,
      error: null,
    },
    info: {
      data: null,
      loader: false,
      error: null,
    },
    simulationOverview: {
      data: null,
      loader: false,
      error: null,
    },
    simulationFunnel: {
      data: null,
      loader: false,
      error: null,
    },
    departmentOutcomes: {
      data: null,
      loader: false,
      error: null,
    },
    finalResults: {
      data: null,
      loader: false,
      error: null,
    },
    participants: {
      data: null,
      loader: false,
      error: null,
    },
    assignmentResends: {
      loader: false,
      error: null,
      result: null,
      token: null,
    },
    extendCollectionPeriod: {
      loader: false,
      error: null,
    },
    resetParticipantDeadlines: {
      loader: false,
      error: null,
      result: null,
      token: null,
    },
    extendParticipantDeadlines: {
      loader: false,
      error: null,
      result: null,
      token: null,
    },
    participantExclusions: {
      loader: false,
      error: null,
      result: null,
      token: null,
    },
    progressResets: {
      loader: false,
      error: null,
      result: null,
      token: null,
    },
    manualCompletions: {
      loader: false,
      error: null,
      result: null,
      token: null,
    },
    manualCompletionReverts: {
      loader: false,
      error: null,
      result: null,
      token: null,
    },
    reminderPauses: {
      loader: false,
      error: null,
      result: null,
      token: null,
    },
    reminderResumes: {
      loader: false,
      error: null,
      result: null,
      token: null,
    },
    notifyManagers: {
      loader: false,
      error: null,
      result: null,
      token: null,
    },
    sendReminders: {
      loader: false,
      error: null,
      result: null,
      token: null,
    },
    participantsCsv: {
      loader: false,
      error: null,
      result: null,
      token: null,
    },
    statusReminders: {
      loader: false,
      error: null,
      result: null,
      token: null,
    },
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case GET_CAMPAIGN_DATA_ASYNC.INITIATE:
        return {
          ...state,
          loader: true,
        }
      case GET_CAMPAIGN_DATA_ASYNC.SUCCESS: {
        let trainings = []

        if (action.payload.data.trainings.length) {
          trainings = action.payload.data.trainings
          trainings = trainings.map((video) => {
            const videoName =
              video.type === TRAINING_VIDEO_TYPES.CUSTOM_CONTENT.value
                ? video.items[0]?.custom_type === CUSTOM_MODULE_TYPES.CUSTOM_VIDEO
                  ? CUSTOM_MODULE_NAME_FILE
                  : CUSTOM_MODULE_NAME_URL
                : video.name

            return {
              ...video,
              name: videoName,
              vendor: getVideoVendor(video),
              items: video.items.map((item) => ({
                ...item,
                embeddedSubtitles: item.embedded_subtitles,
                localeId: item.locale,
                customType: item.custom_type,
                imagePreview:
                  video.type === TRAINING_VIDEO_TYPES.CUSTOM_CONTENT.value
                    ? CUSTOM_MODULE_IMAGE_PREVIEW
                    : item.image_preview || '',
              })),
            }
          })
        } else {
          trainings = [AUTOMATED_LEVEL_BASED_TRAINING]
        }

        return {
          ...state,
          error: null,
          data: {
            ...action.payload.data,
            completionNotificationSettings: mapCompletionNotificationSettingsFromApi(
              action.payload.data.completionNotificationSettings
            ),
            trainings,
          },
          loader: false,
        }
      }
      case GET_CAMPAIGN_DATA_ASYNC.ERROR:
        return {
          ...state,
          error: action.error,
          loader: false,
        }
      case GET_CAMPAIGN_DATA_ASYNC.CANCEL:
        return {
          ...state,
          loader: false,
          segments: null,
        }
      case SEGMENT_FILTER_CHANGE:
        return {
          ...state,
          segment: action.payload.val ? action.payload.val : null,
          loader: true,
          error: null,
        }
      case GET_EMAIL_PREVIEW_ASYNC.INITIATE:
        return {
          ...state,
          emailPreviewError: null,
          emailPreviewLoader: true,
          emailPreview: null,
        }
      case GET_EMAIL_PREVIEW_ASYNC.SUCCESS:
        return {
          ...state,
          emailPreviewLoader: false,
          emailPreview: action.payload.data.response.body,
          data: {
            ...state.data,
            training_campaign_data: {
              ...state.data.training_campaign_data,
              subject: action.payload.data.response.subject,
            },
          },
        }
      case GET_EMAIL_PREVIEW_ASYNC.ERROR:
        return {
          ...state,
          emailPreviewLoader: false,
          emailPreviewError: action.payload.error,
        }
      case GET_REPORT_PARTICIPANTS_LIST_ASYNC.INITIATE:
        return {
          ...state,
          tableLoader: true,
        }
      case GET_REPORT_PARTICIPANTS_LIST_ASYNC.SUCCESS:
        return {
          ...state,
          reportParticipantsData: action.payload.data,
          tableLoader: false,
        }
      case GET_REPORT_PARTICIPANTS_LIST_ASYNC.ERROR:
        return {
          ...state,
          error: action.error,
          tableLoader: false,
        }
      case CHANGE_TABLE_FILTERS:
        return {
          ...state,
          filters: {
            ...state.filters,
            [action.payload.field]: action.payload.value,
          },
        }
      case CLEAR_TABLE_FILTERS:
        return {
          ...state,
          filters: DEFAULT_FILTER,
        }
      case RETRIEVE_EMAIL.INITIATE:
        return {
          ...state,
          emailDetails: {
            data: null,
            error: null,
            loader: true,
          },
        }
      case RETRIEVE_EMAIL.SUCCESS:
        return {
          ...state,
          emailDetails: {
            data: action.payload.data,
            error: null,
            loader: false,
          },
        }
      case RETRIEVE_EMAIL.ERROR:
        return {
          ...state,
          emailDetails: {
            data: null,
            error: action.payload.error,
            loader: false,
          },
        }
      case RETRIEVE_EMAIL.CANCEL:
        return {
          ...state,
          emailDetails: {
            data: null,
            error: null,
            loader: false,
          },
        }
      case GET_REPORT_SUMMARY_ASYNC.INITIATE:
        return {
          ...state,
          summaryLoader: true,
        }
      case GET_REPORT_SUMMARY_ASYNC.SUCCESS:
        return {
          ...state,
          summaryLoader: false,
          summaryData: action.payload.data,
        }
      case GET_REPORT_SUMMARY_ASYNC.ERROR:
        return {
          ...state,
          summaryLoader: false,
        }
      case GET_CAMPAIGN_HEALTH_ASYNC.INITIATE:
        return {
          ...state,
          health: {
            data: null,
            loader: true,
            error: null,
          },
        }
      case GET_CAMPAIGN_HEALTH_ASYNC.SUCCESS:
        return {
          ...state,
          health: {
            data: action.payload.data,
            loader: false,
            error: null,
          },
        }
      case GET_CAMPAIGN_HEALTH_ASYNC.ERROR:
        return {
          ...state,
          health: {
            data: null,
            loader: false,
            error: action.error,
          },
        }
      case GET_CAMPAIGN_HEALTH_ASYNC.CANCEL:
        return {
          ...state,
          health: {
            ...state.health,
            loader: false,
          },
        }
      case GET_CAMPAIGN_STATUS_COUNTS_ASYNC.INITIATE:
        return {
          ...state,
          statusCounts: {
            data: null,
            loader: true,
            error: null,
          },
        }
      case GET_CAMPAIGN_STATUS_COUNTS_ASYNC.SUCCESS:
        return {
          ...state,
          statusCounts: {
            data: action.payload.data,
            loader: false,
            error: null,
          },
        }
      case GET_CAMPAIGN_STATUS_COUNTS_ASYNC.ERROR:
        return {
          ...state,
          statusCounts: {
            data: null,
            loader: false,
            error: action.error,
          },
        }
      case GET_CAMPAIGN_STATUS_COUNTS_ASYNC.CANCEL:
        return {
          ...state,
          statusCounts: {
            ...state.statusCounts,
            loader: false,
          },
        }
      case GET_CAMPAIGN_STATUS_OVER_TIME_ASYNC.INITIATE:
        return {
          ...state,
          statusOverTime: {
            data: null,
            loader: true,
            error: null,
          },
        }
      case GET_CAMPAIGN_STATUS_OVER_TIME_ASYNC.SUCCESS:
        return {
          ...state,
          statusOverTime: {
            data: action.payload.data,
            loader: false,
            error: null,
          },
        }
      case GET_CAMPAIGN_STATUS_OVER_TIME_ASYNC.ERROR:
        return {
          ...state,
          statusOverTime: {
            data: null,
            loader: false,
            error: action.error,
          },
        }
      case GET_CAMPAIGN_STATUS_OVER_TIME_ASYNC.CANCEL:
        return {
          ...state,
          statusOverTime: {
            ...state.statusOverTime,
            loader: false,
          },
        }
      case GET_CAMPAIGN_COMPLETION_PROGRESS_ASYNC.INITIATE:
        return {
          ...state,
          completionProgress: {
            data: null,
            loader: true,
            error: null,
          },
        }
      case GET_CAMPAIGN_COMPLETION_PROGRESS_ASYNC.SUCCESS:
        return {
          ...state,
          completionProgress: {
            data: action.payload.data,
            loader: false,
            error: null,
          },
        }
      case GET_CAMPAIGN_COMPLETION_PROGRESS_ASYNC.ERROR:
        return {
          ...state,
          completionProgress: {
            data: null,
            loader: false,
            error: action.error,
          },
        }
      case GET_CAMPAIGN_COMPLETION_PROGRESS_ASYNC.CANCEL:
        return {
          ...state,
          completionProgress: {
            ...state.completionProgress,
            loader: false,
          },
        }
      case GET_CAMPAIGN_INFO_ASYNC.INITIATE:
        return {
          ...state,
          info: {
            data: null,
            loader: true,
            error: null,
          },
        }
      case GET_CAMPAIGN_INFO_ASYNC.SUCCESS:
        return {
          ...state,
          info: {
            data: action.payload.data,
            loader: false,
            error: null,
          },
        }
      case GET_CAMPAIGN_INFO_ASYNC.ERROR:
        return {
          ...state,
          info: {
            data: null,
            loader: false,
            error: action.error,
          },
        }
      case GET_CAMPAIGN_INFO_ASYNC.CANCEL:
        return {
          ...state,
          info: {
            ...state.info,
            loader: false,
          },
        }
      case GET_CAMPAIGN_SIMULATION_OVERVIEW_ASYNC.INITIATE:
        return {
          ...state,
          simulationOverview: {
            data: null,
            loader: true,
            error: null,
          },
        }
      case GET_CAMPAIGN_SIMULATION_OVERVIEW_ASYNC.SUCCESS:
        return {
          ...state,
          simulationOverview: {
            data: action.payload.data,
            loader: false,
            error: null,
          },
        }
      case GET_CAMPAIGN_SIMULATION_OVERVIEW_ASYNC.ERROR:
        return {
          ...state,
          simulationOverview: {
            data: null,
            loader: false,
            error: action.error,
          },
        }
      case GET_CAMPAIGN_SIMULATION_OVERVIEW_ASYNC.CANCEL:
        return {
          ...state,
          simulationOverview: {
            ...state.simulationOverview,
            loader: false,
          },
        }
      case GET_CAMPAIGN_SIMULATION_FUNNEL_ASYNC.INITIATE:
        return {
          ...state,
          simulationFunnel: {
            data: null,
            loader: true,
            error: null,
          },
        }
      case GET_CAMPAIGN_SIMULATION_FUNNEL_ASYNC.SUCCESS:
        return {
          ...state,
          simulationFunnel: {
            data: action.payload.data,
            loader: false,
            error: null,
          },
        }
      case GET_CAMPAIGN_SIMULATION_FUNNEL_ASYNC.ERROR:
        return {
          ...state,
          simulationFunnel: {
            data: null,
            loader: false,
            error: action.error,
          },
        }
      case GET_CAMPAIGN_SIMULATION_FUNNEL_ASYNC.CANCEL:
        return {
          ...state,
          simulationFunnel: {
            ...state.simulationFunnel,
            loader: false,
          },
        }
      case GET_CAMPAIGN_DEPARTMENT_OUTCOMES_ASYNC.INITIATE:
        return {
          ...state,
          departmentOutcomes: {
            data: null,
            loader: true,
            error: null,
          },
        }
      case GET_CAMPAIGN_DEPARTMENT_OUTCOMES_ASYNC.SUCCESS:
        return {
          ...state,
          departmentOutcomes: {
            data: action.payload.data,
            loader: false,
            error: null,
          },
        }
      case GET_CAMPAIGN_DEPARTMENT_OUTCOMES_ASYNC.ERROR:
        return {
          ...state,
          departmentOutcomes: {
            data: null,
            loader: false,
            error: action.error,
          },
        }
      case GET_CAMPAIGN_DEPARTMENT_OUTCOMES_ASYNC.CANCEL:
        return {
          ...state,
          departmentOutcomes: {
            ...state.departmentOutcomes,
            loader: false,
          },
        }
      case GET_CAMPAIGN_FINAL_RESULTS_ASYNC.INITIATE:
        return {
          ...state,
          finalResults: {
            data: null,
            loader: true,
            error: null,
          },
        }
      case GET_CAMPAIGN_FINAL_RESULTS_ASYNC.SUCCESS:
        return {
          ...state,
          finalResults: {
            data: action.payload.data,
            loader: false,
            error: null,
          },
        }
      case GET_CAMPAIGN_FINAL_RESULTS_ASYNC.ERROR:
        return {
          ...state,
          finalResults: {
            data: null,
            loader: false,
            error: action.error,
          },
        }
      case GET_CAMPAIGN_FINAL_RESULTS_ASYNC.CANCEL:
        return {
          ...state,
          finalResults: {
            ...state.finalResults,
            loader: false,
          },
        }
      case GET_CAMPAIGN_PARTICIPANTS_ASYNC.INITIATE:
        return {
          ...state,
          participants: {
            ...state.participants,
            loader: true,
            error: null,
          },
        }
      case GET_CAMPAIGN_PARTICIPANTS_ASYNC.SUCCESS:
        return {
          ...state,
          participants: {
            data: action.payload.data,
            loader: false,
            error: null,
          },
        }
      case GET_CAMPAIGN_PARTICIPANTS_ASYNC.ERROR:
        return {
          ...state,
          participants: {
            data: null,
            loader: false,
            error: action.error,
          },
        }
      case GET_CAMPAIGN_PARTICIPANTS_ASYNC.CANCEL:
        return {
          ...state,
          participants: {
            ...state.participants,
            loader: false,
          },
        }
      case CREATE_ASSIGNMENT_RESENDS_ASYNC.INITIATE:
        return {
          ...state,
          assignmentResends: {
            ...state.assignmentResends,
            loader: true,
            error: null,
            result: null,
          },
        }
      case CREATE_ASSIGNMENT_RESENDS_ASYNC.SUCCESS:
        return {
          ...state,
          assignmentResends: {
            loader: false,
            error: null,
            result: action.payload.data,
            token: (state.assignmentResends.token || 0) + 1,
          },
        }
      case CREATE_ASSIGNMENT_RESENDS_ASYNC.ERROR:
        return {
          ...state,
          assignmentResends: {
            loader: false,
            error: action.error,
            result: null,
            token: state.assignmentResends.token,
          },
        }
      case CREATE_ASSIGNMENT_RESENDS_ASYNC.CANCEL:
        return {
          ...state,
          assignmentResends: {
            ...state.assignmentResends,
            loader: false,
          },
        }
      case EXTEND_COLLECTION_PERIOD_ASYNC.INITIATE:
        return {
          ...state,
          extendCollectionPeriod: {
            loader: true,
            error: null,
          },
        }
      case EXTEND_COLLECTION_PERIOD_ASYNC.SUCCESS:
        return {
          ...state,
          extendCollectionPeriod: {
            loader: false,
            error: null,
          },
        }
      case EXTEND_COLLECTION_PERIOD_ASYNC.ERROR:
        return {
          ...state,
          extendCollectionPeriod: {
            loader: false,
            error: action.error,
          },
        }
      case EXTEND_COLLECTION_PERIOD_ASYNC.CANCEL:
        return {
          ...state,
          extendCollectionPeriod: {
            ...state.extendCollectionPeriod,
            loader: false,
          },
        }
      case RESET_PARTICIPANT_DEADLINES_ASYNC.INITIATE:
        return {
          ...state,
          resetParticipantDeadlines: {
            ...state.resetParticipantDeadlines,
            loader: true,
            error: null,
            result: null,
          },
        }
      case RESET_PARTICIPANT_DEADLINES_ASYNC.SUCCESS:
        return {
          ...state,
          resetParticipantDeadlines: {
            loader: false,
            error: null,
            result: action.payload.data,
            token: (state.resetParticipantDeadlines.token || 0) + 1,
          },
        }
      case RESET_PARTICIPANT_DEADLINES_ASYNC.ERROR:
        return {
          ...state,
          resetParticipantDeadlines: {
            loader: false,
            error: action.error,
            result: null,
            token: state.resetParticipantDeadlines.token,
          },
        }
      case RESET_PARTICIPANT_DEADLINES_ASYNC.CANCEL:
        return {
          ...state,
          resetParticipantDeadlines: {
            ...state.resetParticipantDeadlines,
            loader: false,
          },
        }
      case EXTEND_PARTICIPANT_DEADLINES_ASYNC.INITIATE:
        return {
          ...state,
          extendParticipantDeadlines: {
            ...state.extendParticipantDeadlines,
            loader: true,
            error: null,
            result: null,
          },
        }
      case EXTEND_PARTICIPANT_DEADLINES_ASYNC.SUCCESS:
        return {
          ...state,
          extendParticipantDeadlines: {
            loader: false,
            error: null,
            result: action.payload.data,
            token: (state.extendParticipantDeadlines.token || 0) + 1,
          },
        }
      case EXTEND_PARTICIPANT_DEADLINES_ASYNC.ERROR:
        return {
          ...state,
          extendParticipantDeadlines: {
            loader: false,
            error: action.error,
            result: null,
            token: state.extendParticipantDeadlines.token,
          },
        }
      case EXTEND_PARTICIPANT_DEADLINES_ASYNC.CANCEL:
        return {
          ...state,
          extendParticipantDeadlines: {
            ...state.extendParticipantDeadlines,
            loader: false,
          },
        }
      case CREATE_PARTICIPANT_EXCLUSIONS_ASYNC.INITIATE:
        return {
          ...state,
          participantExclusions: {
            ...state.participantExclusions,
            loader: true,
            error: null,
            result: null,
          },
        }
      case CREATE_PARTICIPANT_EXCLUSIONS_ASYNC.SUCCESS:
        return {
          ...state,
          participantExclusions: {
            loader: false,
            error: null,
            result: action.payload.data,
            token: (state.participantExclusions.token || 0) + 1,
          },
        }
      case CREATE_PARTICIPANT_EXCLUSIONS_ASYNC.ERROR:
        return {
          ...state,
          participantExclusions: {
            loader: false,
            error: action.error,
            result: null,
            token: state.participantExclusions.token,
          },
        }
      case CREATE_PARTICIPANT_EXCLUSIONS_ASYNC.CANCEL:
        return {
          ...state,
          participantExclusions: {
            ...state.participantExclusions,
            loader: false,
          },
        }
      case RESET_TRAINING_PROGRESS_ASYNC.INITIATE:
        return {
          ...state,
          progressResets: {
            ...state.progressResets,
            loader: true,
            error: null,
            result: null,
          },
        }
      case RESET_TRAINING_PROGRESS_ASYNC.SUCCESS:
        return {
          ...state,
          progressResets: {
            loader: false,
            error: null,
            result: action.payload.data,
            token: (state.progressResets.token || 0) + 1,
          },
        }
      case RESET_TRAINING_PROGRESS_ASYNC.ERROR:
        return {
          ...state,
          progressResets: {
            loader: false,
            error: action.error,
            result: null,
            token: state.progressResets.token,
          },
        }
      case RESET_TRAINING_PROGRESS_ASYNC.CANCEL:
        return {
          ...state,
          progressResets: {
            ...state.progressResets,
            loader: false,
          },
        }
      case CREATE_MANUAL_COMPLETIONS_ASYNC.INITIATE:
        return {
          ...state,
          manualCompletions: {
            ...state.manualCompletions,
            loader: true,
            error: null,
            result: null,
          },
        }
      case CREATE_MANUAL_COMPLETIONS_ASYNC.SUCCESS:
        return {
          ...state,
          manualCompletions: {
            loader: false,
            error: null,
            result: action.payload.data,
            token: (state.manualCompletions.token || 0) + 1,
          },
        }
      case CREATE_MANUAL_COMPLETIONS_ASYNC.ERROR:
        return {
          ...state,
          manualCompletions: {
            loader: false,
            error: action.error,
            result: null,
            token: state.manualCompletions.token,
          },
        }
      case CREATE_MANUAL_COMPLETIONS_ASYNC.CANCEL:
        return {
          ...state,
          manualCompletions: {
            ...state.manualCompletions,
            loader: false,
          },
        }
      case REVERT_MANUAL_COMPLETIONS_ASYNC.INITIATE:
        return {
          ...state,
          manualCompletionReverts: {
            ...state.manualCompletionReverts,
            loader: true,
            error: null,
            result: null,
          },
        }
      case REVERT_MANUAL_COMPLETIONS_ASYNC.SUCCESS:
        return {
          ...state,
          manualCompletionReverts: {
            loader: false,
            error: null,
            result: action.payload.data,
            token: (state.manualCompletionReverts.token || 0) + 1,
          },
        }
      case REVERT_MANUAL_COMPLETIONS_ASYNC.ERROR:
        return {
          ...state,
          manualCompletionReverts: {
            loader: false,
            error: action.error,
            result: null,
            token: state.manualCompletionReverts.token,
          },
        }
      case REVERT_MANUAL_COMPLETIONS_ASYNC.CANCEL:
        return {
          ...state,
          manualCompletionReverts: {
            ...state.manualCompletionReverts,
            loader: false,
          },
        }
      case PAUSE_PARTICIPANT_REMINDERS_ASYNC.INITIATE:
        return {
          ...state,
          reminderPauses: {
            ...state.reminderPauses,
            loader: true,
            error: null,
            result: null,
          },
        }
      case PAUSE_PARTICIPANT_REMINDERS_ASYNC.SUCCESS:
        return {
          ...state,
          reminderPauses: {
            loader: false,
            error: null,
            result: action.payload.data,
            token: (state.reminderPauses.token || 0) + 1,
          },
        }
      case PAUSE_PARTICIPANT_REMINDERS_ASYNC.ERROR:
        return {
          ...state,
          reminderPauses: {
            loader: false,
            error: action.error,
            result: null,
            token: state.reminderPauses.token,
          },
        }
      case PAUSE_PARTICIPANT_REMINDERS_ASYNC.CANCEL:
        return {
          ...state,
          reminderPauses: {
            ...state.reminderPauses,
            loader: false,
          },
        }
      case RESUME_PARTICIPANT_REMINDERS_ASYNC.INITIATE:
        return {
          ...state,
          reminderResumes: {
            ...state.reminderResumes,
            loader: true,
            error: null,
            result: null,
          },
        }
      case RESUME_PARTICIPANT_REMINDERS_ASYNC.SUCCESS:
        return {
          ...state,
          reminderResumes: {
            loader: false,
            error: null,
            result: action.payload.data,
            token: (state.reminderResumes.token || 0) + 1,
          },
        }
      case RESUME_PARTICIPANT_REMINDERS_ASYNC.ERROR:
        return {
          ...state,
          reminderResumes: {
            loader: false,
            error: action.error,
            result: null,
            token: state.reminderResumes.token,
          },
        }
      case RESUME_PARTICIPANT_REMINDERS_ASYNC.CANCEL:
        return {
          ...state,
          reminderResumes: {
            ...state.reminderResumes,
            loader: false,
          },
        }
      case NOTIFY_MANAGERS_ASYNC.INITIATE:
        return {
          ...state,
          notifyManagers: {
            ...state.notifyManagers,
            loader: true,
            error: null,
            result: null,
          },
        }
      case NOTIFY_MANAGERS_ASYNC.SUCCESS:
        return {
          ...state,
          notifyManagers: {
            loader: false,
            error: null,
            result: action.payload.data,
            token: (state.notifyManagers.token || 0) + 1,
          },
        }
      case NOTIFY_MANAGERS_ASYNC.ERROR:
        return {
          ...state,
          notifyManagers: {
            loader: false,
            error: action.error,
            result: null,
            token: state.notifyManagers.token,
          },
        }
      case NOTIFY_MANAGERS_ASYNC.CANCEL:
        return {
          ...state,
          notifyManagers: {
            ...state.notifyManagers,
            loader: false,
          },
        }
      case SEND_REMINDERS_ASYNC.INITIATE:
        return {
          ...state,
          sendReminders: {
            ...state.sendReminders,
            loader: true,
            error: null,
            result: null,
          },
        }
      case SEND_REMINDERS_ASYNC.SUCCESS:
        return {
          ...state,
          sendReminders: {
            loader: false,
            error: null,
            result: action.payload.data,
            token: (state.sendReminders.token || 0) + 1,
          },
        }
      case SEND_REMINDERS_ASYNC.ERROR:
        return {
          ...state,
          sendReminders: {
            loader: false,
            error: action.error,
            result: null,
            token: state.sendReminders.token,
          },
        }
      case SEND_REMINDERS_ASYNC.CANCEL:
        return {
          ...state,
          sendReminders: {
            ...state.sendReminders,
            loader: false,
          },
        }
      case DOWNLOAD_PARTICIPANTS_CSV_ASYNC.INITIATE:
        return {
          ...state,
          participantsCsv: {
            ...state.participantsCsv,
            loader: true,
            error: null,
            result: null,
          },
        }
      case DOWNLOAD_PARTICIPANTS_CSV_ASYNC.SUCCESS:
        return {
          ...state,
          participantsCsv: {
            loader: false,
            error: null,
            result: action.payload,
            token: (state.participantsCsv.token || 0) + 1,
          },
        }
      case DOWNLOAD_PARTICIPANTS_CSV_ASYNC.ERROR:
        return {
          ...state,
          participantsCsv: {
            loader: false,
            error: action.error,
            result: null,
            token: state.participantsCsv.token,
          },
        }
      case DOWNLOAD_PARTICIPANTS_CSV_ASYNC.CANCEL:
        return {
          ...state,
          participantsCsv: {
            ...state.participantsCsv,
            loader: false,
          },
        }
      case SEND_STATUS_REMINDERS_ASYNC.INITIATE:
        return {
          ...state,
          statusReminders: {
            ...state.statusReminders,
            loader: true,
            error: null,
            result: null,
          },
        }
      case SEND_STATUS_REMINDERS_ASYNC.SUCCESS:
        return {
          ...state,
          statusReminders: {
            loader: false,
            error: null,
            result: action.payload.data,
            token: (state.statusReminders.token || 0) + 1,
          },
        }
      case SEND_STATUS_REMINDERS_ASYNC.ERROR:
        return {
          ...state,
          statusReminders: {
            loader: false,
            error: action.error,
            result: null,
            token: state.statusReminders.token,
          },
        }
      case SEND_STATUS_REMINDERS_ASYNC.CANCEL:
        return {
          ...state,
          statusReminders: {
            ...state.statusReminders,
            loader: false,
          },
        }
      case SAVE_DRAFT_ASYNC.INITIATE:
      case DUPLICATE_CAMPAIGN_ASYNC.INITIATE:
        return {
          ...state,
          createdCampaignId: null,
          duplicateCampaignLoader: true,
        }
      case SAVE_DRAFT_ASYNC.SUCCESS:
      case DUPLICATE_CAMPAIGN_ASYNC.SUCCESS:
        return {
          ...state,
          duplicateCampaignLoader: false,
          createdCampaignId: action.payload.id,
        }
      case SAVE_DRAFT_ASYNC.ERROR:
      case DUPLICATE_CAMPAIGN_ASYNC.ERROR:
        return {
          ...state,
          duplicateCampaignLoader: false,
        }
      case EMERGENCY_STOP_REQUEST_ASYNC.INITIATE:
        return {
          ...state,
          campaignStopped: false,
          stopCampaignLoader: true,
        }
      case EMERGENCY_STOP_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          stopCampaignLoader: false,
          campaignStopped: true,
        }
      case EMERGENCY_STOP_REQUEST_ASYNC.ERROR:
      case EMERGENCY_STOP_REQUEST_ASYNC.CANCEL:
        return {
          ...state,
          stopCampaignLoader: false,
          campaignStopped: false,
        }
      case RESET_REPORT:
        return {
          ...initialState,
        }
      case CHANGE_SELECTION_DATA:
        return {
          ...state,
          selectionData: {
            ...state.selectionData,
            [action.payload.field]: action.payload.value,
          },
        }
      case SET_TABLE_FILTERS:
        return {
          ...state,
          filters: action.payload.data,
        }
      case RESET_SELECTION_DATA: {
        return {
          ...state,
          selectionData: DEFAULT_SELECTION_DATA,
        }
      }
      case CHANGE_TRAINING_RESULTS_MODAL_STATUS:
        return {
          ...state,
          trainingResultsModalStatus: action.payload.value,
        }
      case CHANGE_TRAINING_RESULTS_MODAL_POSTPONED_DATE:
        return {
          ...state,
          trainingResultsPostponedDate: action.payload.value,
        }
      case SAVE_MANUAL_TRAINING_RESULTS_ASYNC.INITIATE:
        return {
          ...state,
          trainingResultsModalLoader: true,
        }
      case SAVE_MANUAL_TRAINING_RESULTS_ASYNC.SUCCESS:
        return {
          ...state,
          trainingResultsModalLoader: false,
        }
      case SAVE_MANUAL_TRAINING_RESULTS_ASYNC.ERROR:
        return {
          ...state,
          trainingResultsModalLoader: false,
        }
      case SAVE_MANUAL_TRAINING_RESULTS_ASYNC.CANCEL:
        return {
          ...state,
          trainingResultsModalLoader: false,
        }
      case UPDATE_EMAIL.SUCCESS:
        return {
          ...state,
          emailDetails: {
            data: action.payload.data,
          },
        }
      default:
        return state
    }
  }
}
